import React from 'react'

export default function CreateEvent() {
  return (
    <div>CreateEvent</div>
  )
}
